export enum ModalDismiss {
  Confirm = 'confirm',
  Cancel = 'cancel',
  Backdrop = 'backdrop'
}

export const MODAL_NO_BLUR = {
  cssClass: 'ion-modal-no-blur-no-backdrop'
}
